import { MultivalueSelection } from "../../components/form-controls/types/multivalue-selection.interface";

export enum ASSET_TYPE {
  ID = "assetType",
  TITLE = "Asset Type",
}

export enum ASSET_DIMENSION {
  ID = "assetDimension",
  TITLE = "Size",
}

export enum ASSET_DESCRIPTION {
  ID = "assetDescription",
  TITLE = "Asset Description",
}

export enum IS_SEGMENTED {
  ID = "isSegmented",
  TITLE = "Is Segmented",
}

export enum CTA {
  ID = "cta",
  TITLE = "CTA",
}

export enum DESCRIPTION {
  ID = "positionDescription",
  TITLE = "Description",
}

export enum FROM_PRICING {
  ID = "fromPricing",
  TITLE = "From pricing",
}

export enum SEGMENTS {
  ID = "segments",
  TITLE = "Segments",
}

export enum LEGAL {
  ID = "legal",
  TITLE = "Legal",
}

export enum SITE_PLACEMENT {
  ID = "sitePlacement",
  TITLE = "Site Placement",
}

export enum SUBJECT_LINE_DIRECTION {
  ID = "subjectLineDirection",
  TITLE = "Subject Line Direction",
}

export enum NOTES_FOR_ECOMM {
  ID = "notesForEcomm",
  TITLE = "Notes for eComm",
}

export enum NOTES_FOR_CREATIVE {
  ID = "notesForCreative",
  TITLE = "Notes for Creative",
}

export enum SIZE {
  ID = "size",
  TITLE = "Size",
}

export enum FILE_FORMAT_DESCRIPTION {
  ID = "fileFormatDescription",
  TITLE = "File Format Description",
}

export enum PRE_HEADER_DIRECTION {
  ID = "preHeaderDirection",
  TITLE = "Pre Header Direction",
}

export enum PRIMARY_MESSAGE {
  ID = "primaryMessage",
  TITLE = "Primary Message",
}

export enum SECONDARY_MESSAGE {
  ID = "secondaryMessage",
  TITLE = "Secondary Message",
}

export enum MANDATORY_CREATIVE_DETAILS {
  ID = "mandatoryCreativeDetails",
  TITLE = "Mandatory Creative Details",
}

export enum ADDITIONAL_CREATIVE_DETAILS {
  ID = "additionalCreativeDetails",
  TITLE = "Additional Creative Details",
}

export enum VENDOR_ASSETS_LOCATION {
  ID = "vendorAssetsLocation",
  TITLE = "Vendor Assets Location",
}

export enum IS_BUY_GET {
  ID = "isBuyGet",
  TITLE = "Is Buy Get",
}

export enum ARE_VENDOR_ASSETS_PROVIDED {
  ID = "areVendorAssetsProvided",
  TITLE = "Are Vendor Assets Provided",
}

export enum LEGAL_DETAILS {
  ID = "legalDetails",
  TITLE = "Legal Details",
}

export enum DUE_AT {
  ID = "dueAt",
  TITLE = "Creative Due Date",
}

export enum IS_CREATIVE_REVIEW_REQUIRED {
  ID = "isCreativeReviewRequired",
  TITLE = "Requires Creative Review",
}

export enum COLOUR {
  ID = "colour",
  TITLE = "Colour",
}

export enum OBJECTIVE_OR_PURPOSE {
  ID = "objectiveOrPurpose",
  TITLE = "Objective/Purpose",
}

export enum DEPLOYMENT_DATE {
  ID = "deploymentAt",
  TITLE = "Deployment Date/Time",
}

export enum COPY_DIRECTION {
  ID = "copyDirection",
  TITLE = "Asset Copy Direction",
}

export enum ARE_ADDITIONAL_ASSETS_PROVIDED {
  ID = "areAdditionalAssetsProvided",
  TITLE = "Additional assets provided?",
}

export enum ADDITIONAL_ASSETS_LOCATION {
  ID = "additionalAssetsLocation",
  TITLE = "Additional assets location",
}

export enum IS_EN_REQUIRED {
  ID = "englishRequired",
  TITLE = "Is English Required?",
}

export enum QTY_PER_STORE_EN {
  ID = "englishQtyPerStore",
  TITLE = "Qty per store - English",
}

export enum NUM_OF_STORES_EN {
  ID = "englishNumberOfStores",
  TITLE = "Number of stores - English",
}

export enum NUM_OF_SCREENS_EN {
  ID = "englishNumberOfScreens",
  TITLE = "Number of screens - English",
}

export enum IS_FR_REQUIRED {
  ID = "frenchRequired",
  TITLE = "Is French Required?",
}

export enum QTY_PER_STORE_FR {
  ID = "frenchQtyPerStore",
  TITLE = "Qty per store - French",
}

export enum NUM_OF_STORES_FR {
  ID = "frenchNumberOfStores",
  TITLE = "Number of stores - French",
}

export enum NUM_OF_SCREENS_FR {
  ID = "frenchNumberOfScreens",
  TITLE = "Number of screens - French",
}

export enum CONTENT_DIRECTION {
  ID = "contentDirection",
  TITLE = "Content direction",
}

export enum OFFER_DETAILS {
  ID = "offerDetails",
  TITLE = "Offer details",
}

export enum PROJECT_OVERVIEW {
  ID = "projectOverview",
  TITLE = "Asset Creative Direction",
}

export enum CREATIVE_DIRECTION {
  ID = "creativeDirection",
  TITLE = "Creative Direction",
}

export enum TRAFFICKING_DUE_DATE {
  ID = "traffickingDueAt",
  TITLE = "Trafficking Due Date",
}

export enum REPORTING_MASTER_CAMPAIGN_NAME {
  ID = "reportingMasterCampaignName",
  TITLE = "Reporting Master Campaign Name",
}

export enum CAMPAIGN_TAG {
  ID = "campaignTag",
  TITLE = "Campaign Tag",
}

export enum ASSET_LANGUAGES {
  ID = "assetLanguages",
  TITLE = "Asset Languages",
}

export enum BRANDS_INCLUDED {
  ID = "brandsIncluded",
  TITLE = "Brands Included",
}

export enum CONTENT_NAME {
  ID = "contentName",
  TITLE = "Content Name",
}

export enum THEME {
  ID = "theme",
  TITLE = "Theme",
}

export enum UPLOAD_LOCATION {
  ID = "uploadLocation",
  TITLE = "Upload Location",
}

export enum PHD_BUDGET {
  ID = "phdBudget",
  TITLE = "PHD Budget",
}

export enum UNIT_LINK_ENGLISH {
  ID = "englishAssetUnitLinks",
  TITLE = "Unit Link - English",
}

export enum UNIT_LINK_FRENCH {
  ID = "frenchAssetUnitLinks",
  TITLE = "Unit Link - French",
}

export enum SKU_LIST_REQUIRED {
  ID = "isSkuListRequired",
  TITLE = "SKU List Required",
}

export enum UPLOAD_LOCATION_SKU_LIST {
  ID = "skuListUploadLocation",
  TITLE = "Upload Location for SKU List",
}

export enum UTM_CAMPAIGN {
  ID = "utmCampaign",
  TITLE = "UTM Campaign",
}

export enum UTM_MEDIA {
  ID = "utmMedia",
  TITLE = "UTM Media",
}

export enum UTM_SOURCE {
  ID = "utmSource",
  TITLE = "UTM Source",
}

export enum UTM_CONTENT {
  ID = "utmContent",
  TITLE = "UTM Content",
}

export enum UTM_TERM {
  ID = "utmTerm",
  TITLE = "UTM Term",
}

export enum FUNNEL {
  ID = "funnel",
  TITLE = "Funnel",
}

export enum OVERALL_COMMUNICATION_APPROACH {
  ID = "communicationsApproach",
  TITLE = "Asset Communication Approach",
}

export enum HAS_VENDOR_COMMITMENT {
  ID = "hasVendorCommitment",
  TITLE = "Has Vendor Commitment",
}

export enum VENDOR_APPROVAL_REQUIRED {
  ID = "isVendorApprovalRequired",
  TITLE = "Vendor Approval Required",
}

export enum IN_WAREHOUSE_DATE {
  ID = "warehouseEta",
  TITLE = "In Warehouse Date",
}

export enum PORTAL_OR_PRINT {
  ID = "portalOrPrint",
  TITLE = "Portal / Print",
}

export enum POP_STORE_TYPE {
  ID = "popStoreTypes",
  TITLE = "Store Type",
}

export const SelectionsForPortalOrPrint: MultivalueSelection[] = [
  { label: "Portal", value: "PORTAL" },
  { label: "Print", value: "PRINT" },
];
